import { MsgType } from '@injectivelabs/ts-types'

export const TRADING_MESSAGES = [
  MsgType.MsgLiquidatePosition,
  MsgType.MsgBatchUpdateOrders,
  MsgType.MsgExecuteContractCompat,
  MsgType.MsgCancelDerivativeOrder,
  MsgType.MsgIncreasePositionMargin,
  MsgType.MsgCreateDerivativeLimitOrder,
  MsgType.MsgCreateDerivativeMarketOrder,
  MsgType.MsgBatchCancelDerivativeOrders,
  MsgType.MsgBatchCreateDerivativeLimitOrders
] as MsgType[]

export const RFQ_TRADING_MESSAGES = [
  MsgType.MsgSend,
  MsgType.MsgBatchUpdateOrders,
  MsgType.MsgBatchUpdateOrdersV2,
  MsgType.MsgExecuteContractCompat,
  MsgType.MsgPrivilegedExecuteContractV2
] as MsgType[]
